import { ProductPriceDefault } from './product-price-default';
import { ProductPriceRange } from './product-price-range';

type ProductPriceDefaultProps = {
    className?: string;
    originalPrice?: string;
    price: string;
    type: 'default';
};

type ProductPriceRangeProps = {
    className?: string;
    fromPrice: string;
    isOnSale?: boolean;
    toPrice: string;
    type: 'range';
};

export type ProductPriceDisplayProps = ProductPriceDefaultProps | ProductPriceRangeProps;

export function ProductPriceDisplay(props: Readonly<ProductPriceDisplayProps>) {
    if (props.type === 'range') {
        return (
            <ProductPriceRange
                className={props.className}
                fromPrice={props.fromPrice}
                isOnSale={props.isOnSale}
                toPrice={props.toPrice}
            />
        );
    }

    return <ProductPriceDefault className={props.className} originalPrice={props.originalPrice} price={props.price} />;
}
